import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

export async function fetchInventoryStockSafetyCheck(listQuery) {
  const { data: raw } = await request.get('/inv/inventory-stock/safety-check', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
